import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col, Button } from 'antd'

import './index.css'
import Logo from 'assets/images/ekko-logo.png'
import HtmlIcon from 'assets/images/html-5.svg'
import WordPressIcon from 'assets/images/wordpress.svg'

import { validateChoosePlugin } from 'redux/OnBoardingNow/actions'
import { WEBSITE_WORDPRESS, WEBSITE_CUSTOM } from 'redux/OnBoardingNow/constants'

const ButtonPlugin = ({ icon, title, onClick }) => {
    return (
        <div className="website-type-box" onClick={onClick}>
            <img src={icon} height={48} width={48} />
            <div className="website-box-spacer" />
            <h3 style={{ margin: 0 }}>{title}</h3>
        </div>
    )
}

class StepThree extends React.Component {
    handleClick = plugin => {
        const { choosePlugin } = this.props

        choosePlugin(plugin)
    }

    render() {
        return (
            <Col xs={22} sm={18} md={14}>
                <img src={Logo} height="42" />
                <h2 style={{ paddingTop: 50, marginBottom: 20 }}>Let's add Ekko on your Website.</h2>
                <h2>Choose your website type :</h2>

                <div style={{ paddingTop: 10 }}>
                    <ButtonPlugin
                        icon={WordPressIcon}
                        title="Wordpress website"
                        onClick={() => this.handleClick(WEBSITE_WORDPRESS)}
                    />
                    <ButtonPlugin
                        icon={HtmlIcon}
                        title="Custom website"
                        onClick={() => this.handleClick(WEBSITE_CUSTOM)}
                    />
                </div>
            </Col>
        )
    }
}

const mapStateToProps = ({ onboarding }) => ({})

const mapActionsToProps = dispatch => ({
    choosePlugin: bindActionCreators(validateChoosePlugin, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(StepThree)
